// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"6b6c7970","323":"bab98b3f","453":"9b2cec26","826":"29503426"}[chunkId] + ".chunk.js";
};